var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnauthorized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 546,
    height: 300,
    viewBox: "0 0 546 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10014_212868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.63 260.33H135.89L138.29 219.18H88.22L90.63 260.33Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0499 202.58C95.0499 202.58 37.3999 196.04 44.6599 159.71C51.9299 123.38 95.0499 202.58 95.0499 202.58Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.09 194.81C117.09 194.81 166.45 160.96 142.39 132.78C118.33 104.6 117.09 194.81 117.09 194.81Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.09 194.81V219.18",
    stroke: "#D2D2D2",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.56 193.47C112.56 193.47 63.1999 159.62 87.2599 131.44C111.32 103.26 112.56 193.47 112.56 193.47Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.56 193.47V219.18",
    stroke: "#D2D2D2",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.78 202.09V218.97",
    stroke: "#D2D2D2",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.67 210C125.67 210 157.21 206.42 153.24 186.54C149.26 166.66 125.67 210 125.67 210Z",
    fill: "#D2D2D2",
    stroke: "#D2D2D2",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.82 209.73V218.97",
    stroke: "#D2D2D2",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.99 260.74H0V299.86H545.99V260.74Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.02 24.71L446.96 15.55",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.09 87.27L461.03 78.11",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.91 78.8C470.021 78.8 482.27 66.5505 482.27 51.44C482.27 36.3295 470.021 24.08 454.91 24.08C439.8 24.08 427.55 36.3295 427.55 51.44C427.55 66.5505 439.8 78.8 454.91 78.8Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.91 62.49C461.018 62.49 465.97 57.5383 465.97 51.43C465.97 45.3217 461.018 40.37 454.91 40.37C448.802 40.37 443.85 45.3217 443.85 51.43C443.85 57.5383 448.802 62.49 454.91 62.49Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.6 45.35L490.75 43.26",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.08 59.61L428.23 57.52",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.74 28.26L474.76 20.33",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.45 82.45L440.47 74.52",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.18 65.89L486.13 70.89",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.89 31.77L431.84 36.77",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.79 12.07L424.18 9.56",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.82 29.23L394.21 26.72",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.97 34.07C415.105 34.07 421.7 27.4752 421.7 19.34C421.7 11.2048 415.105 4.61 406.97 4.61C398.835 4.61 392.24 11.2048 392.24 19.34C392.24 27.4752 398.835 34.07 406.97 34.07Z",
    fill: "white",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.97 25.29C410.256 25.29 412.92 22.6261 412.92 19.34C412.92 16.0539 410.256 13.39 406.97 13.39C403.684 13.39 401.02 16.0539 401.02 19.34C401.02 22.6261 403.684 25.29 406.97 25.29Z",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.33 32.11L416.86 36.49",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.08 2.2L399.61 6.58",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.24 23.3L426.12 24.63",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.92 14.25L392.8 15.57",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.22 33.61L401.91 38.49",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.17 0.26L410.86 5.14",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.85 69.47H134.82C129.297 69.47 124.82 73.9472 124.82 79.47V239.03C124.82 244.553 129.297 249.03 134.82 249.03H403.85C409.373 249.03 413.85 244.553 413.85 239.03V79.47C413.85 73.9472 409.373 69.47 403.85 69.47Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.17 78.82H131.49V243.02H407.17V78.82Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.33 76.15C270.252 76.15 271 75.4023 271 74.48C271 73.5577 270.252 72.81 269.33 72.81C268.408 72.81 267.66 73.5577 267.66 74.48C267.66 75.4023 268.408 76.15 269.33 76.15Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.65 74.14H262.99",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.67 74.14H283.01",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.2 205.4L288.32 208.45C275.95 212.27 262.71 212.27 250.34 208.45L240.46 205.4C235.8 203.96 232.62 199.65 232.62 194.77V157.37C232.62 151.22 237.6 146.24 243.75 146.24H294.92C301.07 146.24 306.05 151.22 306.05 157.37V194.77C306.05 199.65 302.87 203.96 298.21 205.4H298.2Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.72 121.54H271.93C281.91 121.54 290.02 129.64 290.02 139.63V146.24H246.63V139.63C246.63 129.65 254.73 121.54 264.72 121.54Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.66 158.25H265.99V181.61H272.66V158.25Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.66 186.28H265.99V192.95H272.66V186.28Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.06 273.06H221.6L230.68 249.03H307.98L317.06 273.06Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.41 273.06H205.25V281.74H333.41V273.06Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.62 209.07C87.06 209.24 85.12 211.48 85.12 214.05V238.9H82.41V194.57C82.41 192.55 80.77 190.91 78.75 190.91C76.73 190.91 75.09 192.55 75.09 194.57V238.9H72.38V192.38C72.38 190.38 70.84 188.63 68.84 188.57C66.84 188.51 65.07 190.17 65.07 192.22V238.89H62.36V198.66C62.36 196.64 60.72 195 58.7 195C56.68 195 55.04 196.64 55.04 198.66V238.89H52.33V209.93C52.33 207.93 50.79 206.18 48.79 206.12C46.79 206.06 45.02 207.72 45.02 209.77V254.98C45.02 268.72 56.15 279.85 69.89 279.85C83.63 279.85 94.76 268.72 94.76 254.98V213.87C94.76 211.1 92.42 208.87 89.61 209.05L89.62 209.07Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.23 216.78L468.55 231.1",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.23 231.1L468.55 216.78",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.39 247.68C474.501 247.68 485.13 237.051 485.13 223.94C485.13 210.829 474.501 200.2 461.39 200.2C448.279 200.2 437.65 210.829 437.65 223.94C437.65 237.051 448.279 247.68 461.39 247.68Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10014_212868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 545.99,
    height: 299.87,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/unauthorized.4f3eee38a45bb5fcde81673be398f0f7.svg";
export { ForwardRef as ReactComponent };